import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { ContextService } from '../../services/context.service';
import { DataService } from '../../services/data.service';
import { ChartModule } from 'primeng/primeng';
import * as chartjs from 'chart.js';


@Component({
  selector: 'app-graph-dimoi-compared',
  templateUrl: './graph-dimoi-compared.component.html',
  styleUrls: ['./graph-dimoi-compared.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class GraphDimoiComparedComponent implements OnInit {



  data: chartjs.ChartData;
  graphType?: 'curve' | 'line' | 'bar' = 'line';
  graphOptions: chartjs.ChartOptions;
  @ViewChild('mainChart') mainChart: any;

  constructor(private app: ContextService, private dataService: DataService) {
    this.updateGraphOptions('bar');
    app.graphDimoiCompared = this;
  }

  ngOnInit() { }

  async redraw() {
    // const data = this.dataService.dataPerDimos;
    const data = this.dataService.getCurrentData();

    const selectedPropertyGroup = this.app.propertySelector.selectedProperty.group;
    const selectedPropertyName = this.app.propertySelector.selectedProperty.name;

    const time = await this.app.timeService.data;

    // console.log();
    const labels = Object.keys(data).map(k => this.app.map.getDimosProperties(parseInt(k, 10)))
      .map(v => (v) ? v['name'] : '');
    // console.log(labels);

    const datasets: chartjs.ChartDataSets[] = [];
    // const numberOfDimoi = Object.keys(data).length;
    const colors = this.app.colorService.getMany(1);
    const data_tmp: chartjs.ChartDataSets = { label: selectedPropertyGroup + ' - ' + selectedPropertyName, data: [] };
    Object.keys(data).forEach((hlpcode, index) => {

      const code = parseInt(hlpcode, 10);
      const value: number = data[code][selectedPropertyGroup][selectedPropertyName];
      (<number[]>data_tmp.data).push(value);
    });

    if (this.graphType === 'bar') {
      data_tmp.fill = colors[0].hex;
      data_tmp.backgroundColor = colors[0].hex;
    } else {
      data_tmp.fill = false;
    }

    data_tmp.borderColor = colors[0].hex;
    datasets.push(data_tmp);
    this.data = {
      labels: labels,
      datasets: datasets
    };
    this.mainChart.refresh();

    // console.log(this.mainChart);
  }




  updateGraphOptions(graphType?: 'curve' | 'line' | 'bar') {
    this.graphType = graphType || 'line';
    this.graphOptions = {
      legend: {
        position: 'bottom',
        display: true
      },
      scales: {
        xAxes: [{
          ticks: {
            maxRotation: 60,
            minRotation: 60,
            autoSkip: false
          }
        }],
        yAxes: [{
          display: true,
          ticks: {
            // suggestedMin: 0,    // minimum will be 0, unless there is a lower value.
            // OR //
            // beginAtZero: true   // minimum value will be 0.
            // callback: function (value: number, index, values) {
            //   return util.numberToThousandDelimitedString(value, ',');
            // }
          }
        }]
      }
    };
    if (graphType === 'line') {
      this.graphOptions.elements = { line: { tension: 0 } };
    }

    // if (this.disAggregated) {
    this.graphOptions.legend.display = false;
    // }
  }


}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/graph-dimoi-compared/graph-dimoi-compared.component.ts